import * as React from 'react';

export default function ExternalLink({
  className,
  viewBox = '0 0 16 16',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.79989 2.40039C8.35807 2.40039 7.99989 2.75856 7.99989 3.20039C7.99989 3.64222 8.35807 4.00039 8.79989 4.00039H10.8685L5.83421 9.03471C5.52179 9.34713 5.52179 9.85366 5.83421 10.1661C6.14663 10.4785 6.65316 10.4785 6.96558 10.1661L11.9999 5.13176V7.20039C11.9999 7.64222 12.3581 8.00039 12.7999 8.00039C13.2417 8.00039 13.5999 7.64222 13.5999 7.20039V3.20039C13.5999 2.75856 13.2417 2.40039 12.7999 2.40039H8.79989Z"
        fill="currentColor"
      />
      <path
        d="M3.9999 4.00039C3.11625 4.00039 2.3999 4.71673 2.3999 5.60039V12.0004C2.3999 12.884 3.11625 13.6004 3.9999 13.6004H10.3999C11.2835 13.6004 11.9999 12.884 11.9999 12.0004V9.60039C11.9999 9.15856 11.6417 8.80039 11.1999 8.80039C10.7581 8.80039 10.3999 9.15856 10.3999 9.60039V12.0004H3.9999V5.60039L6.3999 5.60039C6.84172 5.60039 7.1999 5.24222 7.1999 4.80039C7.1999 4.35856 6.84172 4.00039 6.3999 4.00039H3.9999Z"
        fill="currentColor"
      />
    </svg>
  );
}
